module.exports = __webpack_public_path__ + "img/blue_112.fc502ede.png";